export const apiV1 = process.env.REACT_APP_API_URL_V1
export const sellerUrl = process.env.REACT_APP_SELLER_URL
export const buyerUrl = process.env.REACT_APP_BUYER_URL
export const homeUrl = process.env.REACT_APP_HOME_URL
export const cdnUrl = process.env.NEXT_PUBLIC_CDN_URL
export const api = process.env.REACT_APP_API_URL
